import { useEffect, useState, useRef } from 'react'

export function useVoiceRecognition(maxLength = 0) {
  const [isSupported, setIsSupported] = useState(false)
  const [isRunning, setIsRunning] = useState(false)
  const [voiceText, setVoiceText] = useState('')
  const recognitionRef = useRef()

  useEffect(() => {
    let recognition

    function configureRecognition() {
      const SpeechRecognitionFunction = window.SpeechRecognition || window.webkitSpeechRecognition

      if (!SpeechRecognitionFunction) return

      setIsSupported(true)
      recognition = new SpeechRecognitionFunction()
      recognition.lang = 'pt-BR'
      recognition.interimResults = true
      recognition.continuous = true
      recognition.onstart = onRecognitionStart
      recognition.onend = onRecognitionEnd
      recognition.onerror = onRecognitionError
      recognitionRef.current = recognition

      recognition.onresult = event => {
        const { finalText, isFinal } = handleResults(event.results)

        if (maxLength && finalText.length > maxLength) {
          const slicedText = finalText.slice(0, maxLength)
          setVoiceText(slicedText)
          handleStop()
          return
        }

        setVoiceText(finalText)
        if (isFinal) handleStop()
      }
    }

    configureRecognition()

    return () => recognition.stop()
  }, [maxLength])

  function handleResults(results) {
    if (!results) return
    const resultAsArray = Array.from(results)

    if (!resultAsArray.length) return
    const isFinal = resultAsArray.some(result => result.isFinal)
    const finalText = resultAsArray.map(result => result[0].transcript).join('')

    return { finalText, isFinal }
  }

  function onRecognitionStart() {
    setIsRunning(true)
  }

  function onRecognitionEnd() {
    setIsRunning(false)
  }

  function onRecognitionError() {
    setIsRunning(false)
  }

  function handleStart() {
    const currentRecognition = recognitionRef.current
    if (currentRecognition) currentRecognition.start()
  }

  function handleStop() {
    const currentRecognition = recognitionRef.current
    if (currentRecognition) currentRecognition.stop()
  }

  return {
    isSupported,
    handleStart,
    handleStop,
    isRunning,
    voiceText,
  }
}
